<script>
import StatisticsHeader from "@/components/hr/StatisticsHeader.vue";
import HrTable from "@/components/hr/table/EmployeeTable.vue";
import EmployeesModal from "@/components/hr/modal/employees/EmployeesModal.vue";
import { Statistics } from "@/assets/static.js";
import EmployeesModalEdit from "@/components/hr/modal/employees/EmployeesModalEdit.vue";
import EmployeesModalView from "@/components/hr/modal/employees/EmployeesModalView.vue";
import SkillAddModal from "@/components/hr/modal/employees/SkillAdd.vue";
import SkillEdit from "@/components/hr/modal/employees/SkillEdit.vue";

import DeleteModal from "@/components/hr/modal/DeleteModal.vue";
import router from "@/router";
import SideBar from "@/components/hr/sideBar/EmployeeSideBar";
import DownloadButton from "@/components/custom/PdfPrintButtton.vue";
// ...........................
import { mapGetters, mapActions } from "vuex";
import JsonExcel from "vue-json-excel";
// ...........................

export default {
  name: "HomeComponent",
  components: {
    HrTable,
    StatisticsHeader,
    EmployeesModal,
    EmployeesModalEdit,
    EmployeesModalView,
    DeleteModal,
    SkillAddModal,
    SkillEdit,
    SideBar,
    DownloadButton,
    // .................................
    JsonExcel,
    // .................................
  },
  data: () => ({
    Statisticslist: Statistics,
    showEmployeeModal: false,
    showEditModal: false,
    showViewModal: false,
    showEmployeesModal: false,
    showDeleteModal: false,
    showSkillModal: false,
    showSkillEdit: false,
    showFilter: false,
    skills: [],
    selectedId: 0,
    selectedIdSkill: 0,
    filter: {
      model: [],
      value1: null,
      value2: null,
    },

    menu1: false,
    menu2: false,
    arraydep: null,
    isFilter: null,
  }),
  methods: {
    ...mapActions(["getDepartments"]),
    addEmployee() {
      this.showEmployeeModal = true;
      console.log(this.showEmployeeModal);
    },
    openSkillModal(selectedId) {
      this.selectedId = selectedId;
      this.showSkillModal = true;
    },
    openSkillEditModal(selectedId) {
      console.log(selectedId, "===");
      this.selectedId = selectedId.selectedId;
      this.selectedIdSkill = selectedId.id;
      this.showSkillEdit = true;
    },
    fillSkills(skills) {
      this.skills = skills;
    },
    opendialog(data) {
      this.selectedId = data.selectedId;
      switch (data.index) {
        case 0:
          this.showViewModal = true;
          break;
        case 1:
          this.showEditModal = true;
          break;
        case 2:
          this.showDeleteModal = true;
          break;
        case 3:
          router.push("JobHistory/" + data.selectedId);
          break;
      }
    },
    search(e) {
      var v = e.target.value;
      var filterItem = this.employeesListGet.filter((emp) =>
        emp.name.includes(v)
      );
      this.arraydep = filterItem;
      this.isFilter = true;
    },
    // ...........................
    // ...........................

    printTable() {
      const printWindow = window.open("", "Print", "height=600,width=800");
      const table = document.querySelector("table");

      const rows = table.rows;

      for (let i = 1; i < rows.length; i++) {
        rows[i].deleteCell(-1);
      }
      this.reloadComponent();

      const styles = `
    <style>
    table {
        border-collapse: collapse;
        width: 100%;
        direction: rtl;
      }
      th, td {
        border: 1px solid black;
        padding: 20px;
        text-align: left;
      }
    
    </style>
  `;

      const printContent = `
    <html>
      <head>
        ${styles}
      </head>
      <body>
        ${table.outerHTML}
      </body>
    </html>
  `;
      printWindow.document.body.innerHTML = printContent;

      // // printWindow.close();
      printWindow.print();
    },
    reloadComponent() {
      window.location.reload();
    },
    closeFilter() {
      this.showFilter = !this.showFilter;
      this.isFilter = false;
    },
    openFilterDialog() {
      this.showFilter = !this.showFilter;
      this.filter.model = [];
      this.filter.value1 = null;
      this.filter.value2 = null;
    },
  },
  watch: {
    filter: {
      async handler() {
        if (
          this.filter.model?.length === 0 &&
          !this.filter.value1 &&
          !this.filter.value2
        ) {
          this.isFilter = false;
        } else {
          var filterItem = this.employeesListGet;
          const list = [];
          let v = this.filter.model.map((dep) => dep.name);
          if (v?.length != 0) {
            filterItem = filterItem.filter((emp) => v.includes(emp.department));
          }
          if (this.filter.value1 && this.filter.value2) {
            const date1 = new Date(this.filter.value1);
            const date2 = new Date(this.filter.value2);

            filterItem = filterItem.filter((emp) =>
              new Date(emp.job_date) >= date1 && new Date(emp.job_date) <= date2
                ? list.push(emp)
                : console.log(filterItem)
            );
          }

          if (list.length != 0) {
            this.arraydep = list;
          } else {
            this.arraydep = filterItem;
            console.log(this.arraydep);
          }
          this.isFilter = true;
        }
      },
      deep: true,
    },
  },
  computed: {
    ...mapGetters([
      "paginationGetEmp",
      "employeesListGet",
      "departmentsListGet",
    ]),
  },
  mounted() {
    this.getDepartments({ isModal: true });
  },
  beforeDestroy() {
    this.isFilter = false;
  },
};
</script>
<style>
@import "@/assets/css/global.css";
@import "@/assets/css/style.css";
.v-input__slot {
  padding: 0 !important;
}
</style>
<template>
  <v-sheet class="main_container" height="100%">
    <SideBar />
    <v-sheet class="table_container py-0" height="100%">
      <v-sheet class="header d-flex" height="10vh">
        <v-row width="100%" class="align-start justify-space-between ma-0">
          <v-col cols="12" md="3">
            <v-sheet class="transparent">
              <v-btn
                class="orange rounded-m elevation-0"
                height="4vh"
                width="45%"
                id="importBtn"
                @click.prevent="addEmployee()"
              >
                <v-icon color="white">mdi-plus</v-icon>
                <p class="white--text ma-0">
                  {{ $t("addEmployee") }}
                </p>
              </v-btn></v-sheet
            ></v-col
          >
          <v-col
            cols="12"
            md="4"
            class="d-md-flex d-none align-center justify-space-between"
          >
            <v-sheet class="">
              <v-btn
                v-if="!showFilter"
                outlined
                color="gray0"
                bordercolor="gray0"
                class="ml-8"
                height="4vh"
                id="filtersBtn"
                @click="openFilterDialog()"
              >
                Filters
                <v-icon color="gray0">mdi-filter-outline</v-icon>
              </v-btn>
            </v-sheet>
            <v-sheet
              v-if="!showFilter"
              width="50%"
              class="d-flex align-center justify-center"
            >
              <!-- ........................ -->
              <!-- ........................ -->
              <v-btn
                outlined
                color="gray0"
                class="rounded-0"
                id="printBtn"
                height="4vh"
                @click="printTable"
                >Print</v-btn
              >
              <!-- ........................ -->
              <!-- ........................ -->

              <download-button
                class="btn btn-primary"
                dom="#pdf-content"
                name="Employee.pdf"
              />

              <JsonExcel
                class="btn btn-default"
                :data="this.employeesListGet"
                :fields="json_fields"
                worksheet="My Worksheet"
                name="Employee.xls"
              >
                <v-btn
                  outlined
                  color="gray0"
                  class="rounded-0"
                  height="4vh"
                  id="excelBtn"
                  @click="exportToExcel"
                  >Excel</v-btn
                >
              </JsonExcel>
            </v-sheet>

            <v-sheet>
              <div v-if="showFilter" class="text-center">
                <v-row class="ma-0" style="max-height: 40px">
                  <v-col cols="12" md="6" class="pa-0">
                    <v-menu
                      ref="menu1"
                      v-model="menu1"
                      :close-on-content-click="false"
                      :return-value.sync="filter.value1"
                      transition="scale-transition"
                      offset-y
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          v-model="filter.value1"
                          label="من تاريخ التوظيف"
                          prepend-inner-icon="mdi-calendar"
                          class="orange-icon mx-1 pa-0"
                          v-bind="attrs"
                          v-on="on"
                          outlined
                          dense
                          readonly
                          color="orange"
                          style="max-width: 180px; display: inline-block"
                          hide-details
                          clearable
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        v-model="filter.value1"
                        no-title
                        scrollable
                        color="orange"
                        header-color="orange"
                        class="backGroundCard"
                      >
                        <v-spacer></v-spacer>
                        <v-btn text color="orange" @click="menu1 = false"
                          >Cancel</v-btn
                        >
                        <v-btn
                          text
                          color="orange"
                          @click="$refs.menu1.save(filter.value1)"
                          >OK</v-btn
                        >
                      </v-date-picker>
                    </v-menu>
                  </v-col>
                  <v-col cols="12" md="6" class="pa-0">
                    <v-menu
                      ref="menu2"
                      v-model="menu2"
                      :close-on-content-click="false"
                      :return-value.sync="filter.value2"
                      transition="scale-transition"
                      offset-y
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          v-model="filter.value2"
                          label="إلى تاريخ التوظيف"
                          prepend-inner-icon="mdi-calendar"
                          class="orange-icon mx-1 my-0 pa-0"
                          v-bind="attrs"
                          v-on="on"
                          outlined
                          dense
                          readonly
                          color="orange"
                          style="max-width: 180px; display: inline-block"
                          :hide-details="true"
                          clearable
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        v-model="filter.value2"
                        no-title
                        scrollable
                        color="orange"
                        header-color="orange"
                        class="backGroundCard"
                      >
                        <v-spacer></v-spacer>
                        <v-btn text color="orange" @click="menu2 = false"
                          >Cancel</v-btn
                        >
                        <v-btn
                          text
                          color="orange"
                          @click="$refs.menu2.save(filter.value2)"
                          >OK</v-btn
                        >
                      </v-date-picker>
                    </v-menu>
                  </v-col>
                </v-row>
                <v-row class="mt-1 pa-0 ma-1" style="width: 100%">
                  <v-col cols="12" md="6" class="pa-0">
                    <v-menu offset-y :close-on-content-click="false">
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          color="gray0"
                          outlined
                          bordercolor="gray0"
                          id="filtersBtn"
                          dark
                          v-bind="attrs"
                          v-on="on"
                          style="width: 100%"
                        >
                          القسم
                        </v-btn>
                      </template>
                      <v-list class="px-2">
                        <v-list-item-group v-model="filter.model" multiple>
                          <template v-for="(item, i) in departmentsListGet">
                            <v-list-item
                              :key="`item-${i}`"
                              :value="item"
                              active-class="deep-purple--text text--accent-4"
                            >
                              <template v-slot:default="{ active }">
                                <v-list-item-content>
                                  <v-list-item-title
                                    >{{ item.name }}
                                  </v-list-item-title>
                                </v-list-item-content>

                                <v-list-item-action>
                                  <v-checkbox
                                    :input-value="active"
                                    color="deep-purple accent-4"
                                  ></v-checkbox>
                                </v-list-item-action>
                              </template>
                            </v-list-item>
                          </template>
                        </v-list-item-group>
                      </v-list>
                    </v-menu>
                  </v-col>
                  <v-col cols="12" md="6" class="pa-0">
                    <v-btn
                      v-if="showFilter"
                      outlined
                      color="gray0"
                      bordercolor="gray0"
                      class="mx-2"
                      id="filtersBtn"
                      @click="closeFilter()"
                      style="width: 100%"
                    >
                      Close
                    </v-btn>
                  </v-col>
                </v-row>
              </div>
            </v-sheet>
          </v-col>
          <v-col
            cols="12"
            md="3"
            class="d-flex align-center justify-end justify-md-end"
          >
            <v-sheet
              width="75%"
              height="50%"
              class="d-flex align-center justify-end"
            >
              <v-text-field
                outlined
                dense
                id="searchEmployeeField"
                class="text-center ma-0 pa-0"
                :label="$t('searchEmployee')"
                prepend-inner-icon="mdi-magnify"
                @keyup="search($event)"
              ></v-text-field>
            </v-sheet>
          </v-col>
        </v-row>
      </v-sheet>
      <!-- Statistics -->
      <v-row class="ma-0 my-7 d-none d-md-flex">
        <StatisticsHeader
          v-for="Statistic in Statisticslist"
          :key="Statistic.title"
          :title="Statistic.title"
          :value="
            Statistic?.title === 'all'
              ? (Statistic.value = paginationGetEmp?.total)
              : Statistic.value
          "
        />
      </v-row>
      <!--  Statistics End -->

      <v-sheet class="transparent" id="pdf-content">
        <HrTable
          @actionMenu="opendialog"
          :dataFilter="arraydep"
          :isFilter="isFilter"
        />
      </v-sheet>

      <v-sheet v-if="showEmployeeModal">
        <EmployeesModal
          :skills="skills"
          :value="showEmployeeModal"
          @input="showEmployeeModal = $event"
        />
      </v-sheet>
      <v-sheet v-if="showEditModal">
        <EmployeesModalEdit
          :id="selectedId"
          :value="showEditModal"
          @input="showEditModal = $event"
          @openSkills="openSkillModal"
          @openSkillsEdit="openSkillEditModal"
        />
      </v-sheet>
      <v-sheet v-if="showViewModal">
        <EmployeesModalView
          :id="selectedId"
          :value="showViewModal"
          @input="showViewModal = $event"
          @openSkills="openSkills"
        />
      </v-sheet>
      <v-sheet v-if="showDeleteModal">
        <DeleteModal
          action="deleteEmployee"
          :id="selectedId"
          :value="showDeleteModal"
          @input="showDeleteModal = $event"
        />
      </v-sheet>
      <v-sheet v-if="showSkillModal">
        <SkillAddModal
          :selectedId="selectedId"
          :value="showSkillModal"
          @input="showSkillModal = $event"
          @fillSkills="fillSkills"
        />
      </v-sheet>
      <v-sheet v-if="showSkillEdit">
        <SkillEdit
          :selectedId="selectedId"
          :id="selectedIdSkill"
          :value="showSkillEdit"
          @input="showSkillEdit = $event"
          @fillSkills="fillSkills"
        />
      </v-sheet>
    </v-sheet>
  </v-sheet>
</template>
